var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Über Lauer Inventurservice")]),_c('h2',[_vm._v("Admin UI")]),_c('p',[_vm._v("© 2018 by"),_c('br'),_vm._v(" \n  Dipl.- Volkswirt J. Lauer Nachf. "),_c('br'),_vm._v("\n  GmbH & Co. KG ")])])
}]

export { render, staticRenderFns }